import React from 'lib/react';
import {
  makeStyles, EVGrid,
  EVButton, EVPaper,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useDispatch } from 'lib/redux';
import { Link } from 'lib/router';
import {
  SUPPORT_ROUTE,
} from 'constants/RouteConstants';
import Typography from 'commonComponents/typography';
import { loadFinalizeOrderPage } from '../FinalizeOrder.actions';

const useStyles = makeStyles(() => ({
  retryScreen: {
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
  },
  retryScreenContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '@media (max-width: 1024px)': {
      padding: '0px 24px 0px 24px',
      gap: '10px',
    },
  },
  errorPlacingOrderText: {
    fontWeight: '300',
    fontSize: '36px',
    textTransform: 'capitalize',
  },
  errorPlacingOrderTextDesc: {
    textOverflow: 'ellipsis',
  },
  goBackButton: {
    width: 'max-content',
    textTransform: 'capitalize',
    '@media (max-width: 1024px)': {
      width: 'auto',
    },
  },
}));

function OrderFailedRetryPage() {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const handleGoBack = () => dispatch(loadFinalizeOrderPage());
  return (
    <EVPaper elevation={0} className={classes.retryScreen}>
      <EVGrid className={classes.retryScreenContainer}>
        <EVGrid>
          <Typography fontColor="ocean-700" className={classes.errorPlacingOrderText}>
            {t('place_order__error')}
          </Typography>
          <Typography variant="body-400" className={classes.errorPlacingOrderTextDesc}>
            {t('place_order__error_description')}
          </Typography>
          <Typography>
            {t('place_order__or')}
            {' '}
            <Link underline="always" className={classes.supportLink} to={SUPPORT_ROUTE}>{t('place_order__contact_support')}</Link>
            .
          </Typography>
        </EVGrid>
        <EVButton id="goBackBtn" variant="contained" color="primary" className={classes.goBackButton} onClick={() => handleGoBack()}>
          {t('place_order__go_back')}
        </EVButton>
      </EVGrid>
    </EVPaper>
  );
}

export default OrderFailedRetryPage;
